<lin-layout-section [title]="'CLIENT.VEHICLES.NEW_VEHICLE' | translate">
  @if (!isLoaded) {
  <lin-spinner></lin-spinner>
  } @if (isLoaded) {
  <form lin-layout-form [formGroup]="vehicleForm" (ngSubmit)="saveData()">
    <lin-layout-form-sections-wrapper>
      <lin-layout-form-section layout="triple">
        <lin-form-label required>{{ 'CLIENT.VEHICLES.TYPE' | translate }}:</lin-form-label>
        <lin-improved-select
          controlName="type"
          [control]="vehicleForm.get('type')"
          optionValueKey="id"
          [required]="true"
          [hasSearch]="true"
          [staticSearch]="true"
          [staticList]="true"
          [selectedOption]="vehicle?.typeId || ''"
          [preloadedOptions]="vehicleTypesList"
          [displayOptionLabel]="displayVehicleType"
          (selectOption)="handleVehicleTypeSelect($event.value)"
        ></lin-improved-select>

        <label>{{ 'CLIENT.VEHICLES.MAKE' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="make" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('make')" controlName="make"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.MODEL' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="makeModel" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('makeModel')" controlName="makeModel"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label required>{{ 'CLIENT.VEHICLES.VEHICLE_TITLE' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="vehicleTitle" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('vehicleTitle')" controlName="vehicleTitle"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label required>{{ 'CLIENT.VEHICLES.REG_NO' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="regNo" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('regNo')" controlName="regNo"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <ng-container>
          <label>{{ 'CLIENT.VEHICLES.DEPOT' | translate }}:</label>
          <mat-form-field>
            <mat-select formControlName="depot">
              @for (depot of depots; track depot.id) {
              <mat-option [value]="depot.id">{{ depot.name }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="vehicleForm.get('depot')" controlName="depot"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        </ng-container>

        <label>{{ 'CLIENT.VEHICLES.VIN' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="vin" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('vin')" controlName="vin"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.PRODUCTION_YEAR' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="regDate" autocomplete="off" type="number" min="1900" [max]="currentYear" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('regDate')" controlName="regDate"></lin-form-field-error>
          </mat-error>
        </mat-form-field>
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        <label>{{ 'CLIENT.VEHICLES.ENGINE_POWER' | translate }}:</label>
        <mat-form-field>
          <input matInput type="number" min="0" linNumbersOnly formControlName="enginePower" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('enginePower')" controlName="enginePower"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.ENGINE_CAPACITY' | translate }}:</label>
        <mat-form-field>
          <input matInput type="number" min="0" linNumbersOnly formControlName="engineCapacity" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('engineCapacity')" controlName="engineCapacity"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <ng-container>
          <label>{{ 'CLIENT.VEHICLES.FUEL_TYPE' | translate }}:</label>
          <mat-form-field>
            <mat-select formControlName="fuelType">
              @for (fuelType of fuel; track fuelType.id) {
              <mat-option [value]="fuelType.id">{{ FuelTypeLabel[fuelType.name] | translate }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="vehicleForm.get('fuelType')" controlName="fuelType"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        </ng-container>

        <label>{{ 'CLIENT.VEHICLES.FUEL_TANK_CAPACITY' | translate }}:</label>
        <mat-form-field>
          <input matInput type="number" min="0" linNumbersOnly formControlName="fuelTankCapacity" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('fuelTankCapacity')" controlName="fuelTankCapacity"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.AVERAGE_FUEL_CONSUMPTION' | translate }}:</label>
        <mat-form-field>
          <input matInput type="number" min="0" linNumbersOnly formControlName="averageFuel" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('averageFuel')" controlName="averageFuel"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.EMISSION_CLASS' | translate }}:</label>
        <mat-form-field>
          <mat-select formControlName="emissionClass">
            @for (emissionClass of emissionClasses; track emissionClass.id) {
            <mat-option [value]="emissionClass.id"> {{ emissionClass.displayName }} {{ emissionClass.id }} </mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('emissionClass')" controlName="emissionClass"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.CO_TWO_EMISSION' | translate }}:</label>
        <mat-form-field>
          <input matInput type="number" min="0" linNumbersOnly formControlName="co2Emissions" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('co2Emissions')" controlName="co2Emissions"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.GROSS_WEIGHT' | translate }}:</label>
        <mat-form-field>
          <input matInput type="number" min="0" linNumbersOnly formControlName="grossWeight" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('grossWeight')" controlName="grossWeight"></lin-form-field-error>
          </mat-error>
        </mat-form-field>
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        <label>{{ 'CLIENT.VEHICLES.ECO_SPEED' | translate }}:</label>
        <mat-form-field>
          <input
            [placeholder]="ecoSpeed?.value?.value"
            matInput
            type="number"
            min="0"
            linNumbersOnly
            formControlName="ecoSpeed"
            autocomplete="off"
          />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('ecoSpeed')" controlName="ecoSpeed"></lin-form-field-error>
          </mat-error>
          @if (!vehicleForm.controls.ecoSpeed.value) {
          <mat-hint>{{ 'CLIENT.VEHICLES.DEFAULT_SETTING' | translate }}</mat-hint>
          }
        </mat-form-field>

        <label>{{ 'CLIENT.VEHICLES.EXCESSIVE_IDLING' | translate }}:</label>
        <mat-form-field>
          <input
            [placeholder]="excessiveIdling?.value?.value"
            matInput
            type="number"
            min="0"
            linNumbersOnly
            formControlName="excessiveIdling"
            autocomplete="off"
          />
          <mat-error>
            <lin-form-field-error [control]="vehicleForm.get('excessiveIdling')" controlName="excessiveIdling"></lin-form-field-error>
          </mat-error>
          @if (!vehicleForm.controls.excessiveIdling.value) {
          <mat-hint>{{ 'CLIENT.VEHICLES.DEFAULT_SETTING' | translate }}</mat-hint>
          }
        </mat-form-field>
      </lin-layout-form-section>
    </lin-layout-form-sections-wrapper>

    <lin-layout-form-toolbar>
      <lin-form-submit-button [isLoading]="isSubmitting" [isDisabled]="!PermissionsSource['FLEET.VEHICLE_LIST.ADD']">
        {{ 'BUTTONS.SAVE' | translate }}
      </lin-form-submit-button>
    </lin-layout-form-toolbar>
  </form>
  }
</lin-layout-section>
